import './IncidentCancellationContextMenuPart.scss'

import IEntityIncident from '../../interfaces/entityIncident/IEntityIncident'
import { useMsal } from '@azure/msal-react'
import { useState } from 'react'
import IApplicationSettings from '../../interfaces/applicationSettings/IApplicationSettings'
import StandardActionButton from '../standardButton/standardActionButton/StandardActionButton'
import ICustomer from '../../interfaces/customer/ICustomer'
import { OverlayTrigger, Popover } from 'react-bootstrap'


type ComponentProps = {
  customer: ICustomer
  entityIncidents:IEntityIncident[]
  applicationSettings: null|undefined|IApplicationSettings
  handleIncidentCancellation: (entityIncidents:IEntityIncident[], reason:string, reasonRemark:string) => void
}

const IncidentCancellationContextMenuPart = (props:ComponentProps) => {
  
  const {instance } = useMsal()

  let user = instance.getActiveAccount()

  let allowIncidentCancellationCorrect:boolean = false
  let allowIncidentCancellationIncorrect:boolean = false 

  if (props.applicationSettings)
  {
    if (props.applicationSettings?.AllowIncidentCancellationCorrect) 
      allowIncidentCancellationCorrect = (Number.parseInt(props.applicationSettings.AllowIncidentCancellationCorrect) != 0)
    if (props.applicationSettings?.AllowIncidentCancellationIncorrect) 
      allowIncidentCancellationIncorrect = (Number.parseInt(props.applicationSettings.AllowIncidentCancellationIncorrect) != 0)
  }

  const [correctReasonRemark, setCorrectReasonRemark] = useState('')
  const [incorrectReasonRemark, setIncorrectReasonRemark] = useState('')

  const hidePopover = (popoverID: string) => {
    const popover = document.getElementById(popoverID)
    popover?.style.setProperty('display', 'none')
  }

  const handleIncidentCancellation = (entityIncidents:IEntityIncident[], reason:string, reasonRemark:string) => {
    hidePopover('incident-item-cancellation-popover')
    props.handleIncidentCancellation(entityIncidents, reason, reasonRemark)
  }


  const renderContextMenu:any = (entityIncidents:IEntityIncident[]) => (
    <Popover id='incident-item-cancellation-popover' className='incident-item-cancellation-popover' onClick={(event) => event.stopPropagation()}>
      <Popover.Header className='incident-item-cancellation-popover-header'>Annullering af hændelsen</Popover.Header>
      <Popover.Body className='incident-item-cancellation-popover-body'>
        {
          allowIncidentCancellationCorrect &&
          <div className='entity-item-cancellation-section'>
            <div className='entity-item-cancellation-section-headline'>Jeg håndterer hændelsen selv</div>
            <div className='cancellation-reason-item'>
              <div className='reason'>
                  Sense har ret i den konkrete vurdering, men jeg ønsker at håndtere den på anden vis.
              </div>
              <div className='reason-remark'>
                <input
                  className='reason-remark-input'
                  spellCheck='false'
                  placeholder='Årsag (<200 tegn)'
                  onChange={(event: React.FormEvent<HTMLInputElement>) => setCorrectReasonRemark(event.currentTarget.value) }>
                </input>
                <div className='reason-remark-button-container'>
                  <StandardActionButton key='incident-cancellation-correct-button' status={correctReasonRemark ? 'enabled' : 'disabled'} id='incident-cancellation-correct-button' title='OK' onClick={() => {handleIncidentCancellation(entityIncidents, 'CorrectSystemAssessmentExternalHandling', correctReasonRemark)}} />
                </div>        
              </div>
            </div>
          </div>
        }
        {
          allowIncidentCancellationIncorrect &&
          <div className='entity-item-cancellation-section'>
            <div className='entity-item-cancellation-section-headline'>Fejlvurdering af indhold</div>
            <div className='cancellation-reason-item'>
              <div className='reason'>
                  Sense tager fejl i den konkrete vurdering. Den skal ikke håndteres.
              </div>
              <div className='reason-remark'>
                <input
                  className='reason-remark-input'
                  spellCheck='false'
                  placeholder='Bud på fejl (<200 tegn)'
                  onChange={(event: React.FormEvent<HTMLInputElement>) => setIncorrectReasonRemark(event.currentTarget.value) }>
                </input>
                <div className='reason-remark-button-container'>
                  <StandardActionButton key='incident-cancellation-incorrect-button' status={incorrectReasonRemark ? 'enabled' : 'disabled'} id='incident-cancellation-incorrect-button' title='OK' onClick={() => {handleIncidentCancellation(entityIncidents, 'IncorrectSystemAssessment', incorrectReasonRemark)}} />
                </div>        
              </div>
            </div>
          </div>
        }
      </Popover.Body>
    </Popover>
  )

  return (
    <> 
      <OverlayTrigger trigger={['click']} rootClose={true} placement='auto' overlay={renderContextMenu(props.entityIncidents) }>
        <div>
          Annullering...
        </div>        
      </OverlayTrigger>
    </>
  )
}

export default IncidentCancellationContextMenuPart